import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { mainPageQueries } from '@/services/mainPage/mainPage.queries';

export const useMainPageShuffle = () => {
  const { data, isFetched, isLoading } = useQuery({
    ...mainPageQueries.shuffle(),
  });

  return {
    mainPageShuffle: data?.data,
    isFetched,
    isLoading,
  };
};
